import { IState } from '../../store';
import { EBookingStatus } from '../../types/newbuildingBooking';

export const selectIsBookingLoading = (state: IState): boolean => {
  return state.newbuildingBooking.status === EBookingStatus.Loading;
};
